import { orderBy, uniqBy } from 'lodash';

export function updateListItems(
  currentItems: any,
  addedAndUpdatedItem: any,
  create: (data: any) => any,
): any[] {
  if (!currentItems || !addedAndUpdatedItem || !addedAndUpdatedItem.length) {
    return [currentItems || [], []];
  }
  const newItems = addedAndUpdatedItem
    .filter((newItem: any) => {
      const oldItem = currentItems.find((i: any) => i.id == newItem.id);
      if (oldItem) {
        oldItem.update(newItem);
        return true;
      } else {
        return true;
      }
    })
    .map(create);

  let finalItems = [...currentItems, ...newItems];
  finalItems = uniqBy(finalItems, 'id');
  finalItems = orderBy(finalItems, ['createdTime', 'id'], ['desc', 'desc']);

  return [finalItems, newItems];
}
